import React from "react";
import { useProviderInfoPageContext } from "../Context";
import { withRouter } from "react-router-dom";
import { ProviderInfoMap } from "./ProviderInfoMap";

const BeforeRouterMap = () => {
    const { metadata, provider } = useProviderInfoPageContext();
    return <ProviderInfoMap metadata={metadata} provider={provider} />;
};

export const ProviderInfoMapWithContext = withRouter(BeforeRouterMap);
